<template>
  <div>
    <v-container class="page__wrapper" style="position: relative">
      <v-btn
        icon
        style="position: absolute; top: 10px; left: 10px"
        @click="back"
      >
        <v-icon color="primary" style="font-size: 45px"
          >mdi-chevron-left</v-icon
        >
      </v-btn>
      <div class="mt-5">
        <h2 class="mb-3">
          {{ $t('Picture') }}
          {{ (typeof ImageSelect === 'object' ? 0 : ImageSelect) + 1 }}
        </h2>
        <div ref="setWidth" class="setKonvaWidth"></div>

        <div class="form-group">
          <!-- <input
          type="file"
          accept="image/*"
          @change="previewImage"
          class="form-control-file"
          id="my-file"
        /> -->
          <v-btn
            color="primary"
            class="text-none mb-2"
            rounded
            depressed
            :loading="isSelecting"
            @click="onButtonClick"
          >
            <v-icon left> mdi-cloud-upload </v-icon>
            {{ buttonText }}
            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept="image/*"
              @change="previewImage"
            />
          </v-btn>

          <v-btn
            v-if="preview"
            icon
            small
            class="ml-2 color-primary"
            @click="clearImage"
          >
            <v-icon> mdi-close</v-icon>
          </v-btn>
          <p>
            <small>{{
              $t(
                '* If the background image is not selected, the background will be black.'
              )
            }}</small>
          </p>
          <!-- <v-file-input
            color="primary accent-4"
            dense
            outlined
            label="Select your files"
            prepend-icon="mdi-paperclip"
            type="file"
            accept="image/*"
            @change="previewImage"
            class="form-control-file"
            ref="selectFile"
          >
            <template v-slot:selection="{ index, text }">
              <v-chip v-if="index < 2" color="primary accent-4" dark label small>
                {{ text }}
              </v-chip>
            </template>
          </v-file-input> -->

          <div class="border p-2 mt-3">
            <template>
              <v-stage
                id="template2Set"
                ref="stage"
                :config="{
                  ...stageSize,
                  width: stageSize.width * scaleState,
                  height: stageSize.height * scaleState,
                  scale: {
                    x: scaleState,
                    y: scaleState
                  }
                }"
                style="text-align: -webkit-center"
                @mousedown="handleStageMouseDown"
                @touchstart="handleStageMouseDown"
              >
                <v-layer ref="layer">
                  <template v-for="(item, index) in layerItems">
                    <v-rect
                      v-if="item.type == 'bgRect'"
                      :key="`rect___${index}`"
                      :config="{
                        x: item.x,
                        y: item.y,
                        fill: item.fill,
                        stroke: item.fill !== '#FEFEFE' ? null : item.stroke,
                        width: stageSize.width,
                        height: stageSize.height,
                        rotation: item.rotation,
                        scaleX: item.scaleX,
                        scaleY: item.scaleY
                      }"
                      @click="setSelect(index, $event)"
                      @touchstart="setSelect(index, $event)"
                    ></v-rect>
                    <v-image
                      v-if="preview && item.type == 'bgImage'"
                      :key="`bgImage___${index}`"
                      :config="{
                        x: item.x,
                        y: item.y,
                        rotation: item.rotation,
                        scaleX: item.scaleX,
                        scaleY: item.scaleY,
                        draggable: item.draggable,
                        name: item.name,
                        fill: item.fill,
                        width: item.width,
                        height: item.height,
                        image: preview
                      }"
                      @click="setSelect(index, $event)"
                      @touchstart="setSelect(index, $event)"
                      @transformend="handleTransformEnd"
                    />
                    <v-image
                      v-if="item.type == 'image'"
                      :ref="item.name"
                      :key="`imageIcons___${index}`"
                      :config="item"
                      @transformend="handleTransformEnd"
                      @click="setSelect(index, $event)"
                      @touchstart="setSelect(index, $event)"
                      @dragmove="dragCheckOver(index, $event)"
                    />
                    <v-text
                      v-if="item.type == 'text'"
                      :ref="item.name"
                      :key="`text___${index}`"
                      :config="{
                        ...item,
                        fontSize: item.fontSize * 4.2
                      }"
                      @click="setSelect(index, $event)"
                      @dblclick="dbEditText(index, $event)"
                      @touchstart="setSelect(index, $event)"
                      @transformend="handleTransformEnd"
                      @dragmove="dragCheckOver(index, $event)"
                    />
                    <!-- @dblclick="editText"
                      @dbltap="editText" -->
                  </template>
                  <v-image
                    v-if="
                      scaleState !== 1 &&
                      layerItems[0].fill === '#FEFEFE' &&
                      layerItems.length < 3 &&
                      !preview
                    "
                    :config="{
                      x: stageSize.width / 2 - 150 / 2,
                      y: stageSize.height / 2 - 150 / 2,
                      fill: '#FEFEFE',
                      width: 150,
                      height: 150,
                      image: addImage
                    }"
                    @touchstart="fileInput"
                    @click="fileInput"
                    @mouseenter="handleMouseEnter"
                    @mouseleave="handleMouseLeave"
                  />
                  <v-text
                    v-if="
                      scaleState !== 1 &&
                      layerItems[0].fill === '#FEFEFE' &&
                      layerItems.length < 3 &&
                      !preview
                    "
                    :config="{
                      text: `${(stageSize.width / scaleState).toFixed(0)} x ${(
                        stageSize.height / scaleState
                      ).toFixed(0)}`,
                      x: stageSize.width / 2,
                      y: stageSize.height - 20,
                      width: stageSize.width + 30,
                      align: 'right',
                      fill: 'var(--v-primary-lighten2)'
                    }"
                  />
                  <v-transformer ref="transformer" />
                </v-layer>
              </v-stage>
            </template>
            <div class="text-center mt-5 mb-5">
              <!-- <v-btn outlined fab small @click="addRectangle" class="w45 br-7"
              ><v-icon>mdi-rectangle-outline</v-icon></v-btn
            > -->
              <!-- <v-btn outlined fab small @click="addIcons" class="w45 br-7"
              ><v-icon>mdi-emoticon-happy-outline</v-icon></v-btn
            > -->
              <v-btn outlined fab small class="w45 br-7" @click="addText"
                ><v-icon>mdi-format-text</v-icon></v-btn
              >
              <template
                v-if="
                  layerItems[layerIndex].type !== 'bgRect' &&
                  layerItems[layerIndex].type !== 'bgImage'
                "
              >
                <v-btn outlined fab small class="w45 br-7" @click="rotate(-90)">
                  <v-icon>mdi-rotate-left</v-icon></v-btn
                >
                <v-btn outlined fab small class="w45 br-7" @click="rotate(90)">
                  <v-icon>mdi-rotate-right</v-icon></v-btn
                >
                <v-btn outlined fab small class="w45 br-7" @click="alignLeft"
                  ><v-icon>mdi-arrow-collapse-left</v-icon></v-btn
                >
                <v-btn outlined fab small class="w45 br-7" @click="alignRight"
                  ><v-icon>mdi-arrow-collapse-right</v-icon></v-btn
                >
                <v-btn outlined fab small class="w45 br-7" @click="alignCenter"
                  ><v-icon>mdi-arrow-collapse-horizontal</v-icon></v-btn
                >
                <v-btn outlined fab small class="w45 br-7" @click="alignUp"
                  ><v-icon>mdi-arrow-collapse-up</v-icon></v-btn
                >
                <v-btn
                  outlined
                  fab
                  small
                  class="w45 br-7"
                  @click="alignUpCenter"
                  ><v-icon>mdi-arrow-collapse-vertical</v-icon></v-btn
                >
                <v-btn outlined fab small class="w45 br-7" @click="alignDown"
                  ><v-icon>mdi-arrow-collapse-down</v-icon></v-btn
                >
              </template>
              <v-btn
                v-if="
                  layerItems[layerIndex].type !== 'bgRect' &&
                  layerItems[layerIndex].type !== 'bgImage'
                "
                outlined
                fab
                small
                class="w45 br-7"
                @click="deleteItem(layerIndex)"
              >
                <v-icon>mdi-delete-outline</v-icon></v-btn
              >
              <!-- <v-btn outlined fab small @click="alignDown" class="w45 br-7"
              ><v-icon>mdi-arrow-collapse-down</v-icon></v-btn
            > -->
            </div>
            <div
              v-if="
                layerItems[layerIndex].type === 'text' ||
                layerItems[layerIndex].type === 'bgRect'
              "
            >
              <v-select
                v-if="layerItems[layerIndex].type === 'text'"
                v-model="layerItems[layerIndex].fontFamily"
                class="mt-5"
                :items="fonts"
                label="Font style"
                dense
                outlined
              ></v-select>
              <v-text-field
                v-if="layerItems[layerIndex].type === 'text'"
                ref="edit_text"
                v-model="layerItems[layerIndex].text"
                label="Text"
                dense
                outlined
                clearable
                @focus="isStillEditText = true"
                @blur="isStillEditText = false"
              ></v-text-field>
              <v-text-field
                v-if="layerItems[layerIndex].type === 'text'"
                v-model="layerItems[layerIndex].fontSize"
                label="Font size"
                type="number"
                dense
                outlined
                clearable
                @focus="isStillEditText = true"
                @blur="isStillEditText = false"
              ></v-text-field>
              <v-color-picker
                v-model="layerItems[layerIndex].fill"
                class="ma-auto"
              ></v-color-picker>
            </div>

            <!-- <template>
              <v-expansion-panels class="card-reports">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Controller
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-list dense>
                      <v-list-item v-for="(item, i) in layerItems" :key="`reports___${i}`">
                        <v-list-item-content
                          @click="setSelect(i)"
                          :style="layerIndex === i ? 'color: #fe1266' : 'color: #000000'"
                        >
                          <v-list-item-title v-text="item.text"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action
                          @click="deleteItem(i)"
                          v-if="item.type !== 'bgRect' && item.type !== 'bgImage'"
                        >
                          <v-btn icon>
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </template> -->
          </div>
        </div>
      </div>
      <!-- <template>
        <div class="btn-sticky mt-5 pr-pl-12">

          <v-btn outlined class="btn-custom btn-next-richmenu w45 right" @click="submitData"
            ><span>Next</span>
          </v-btn>
        </div>
      </template> -->
      <template>
        <v-card class="command-bar">
          <div class="btn-sticky mt-5 pr-pl-12 sticky-left">
            <v-btn
              outlined
              class="btn-custom right btn-custom-outline-color"
              :href="how_to_use_blog"
              target="blank"
              depressed
              rounded
            >
              <v-icon>mdi-help-circle</v-icon
              ><span class="ml-1"> {{ $t('How to use') }}</span>
            </v-btn>
          </div>
          <div class="btn-sticky mt-5 pr-pl-12 sticky-right">
            <v-btn
              outlined
              class="btn-custom btn-next-richmenu right"
              style="width: 180px"
              @click="submitData"
              ><span>{{ $t('save_and_next') }}</span>
            </v-btn>
          </div>
        </v-card>
      </template>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import icon from '../../assets/image/logo/Logo_black.png'
import addImage from '../../assets/image/icons/addImage.png'
import configUrl from '@/config'
export default {
  components: {},
  data() {
    return {
      fonts: [
        'Monospace',
        'Arial',
        'Verdana',
        'Helvetica',
        'Tahoma',
        'Trebuchet MS',
        'Times New Roman',
        'Georgia',
        'Garamond',
        'Courier New',
        'Brush Script MT'
      ],
      stageSize: {
        width: null,
        height: null,
        fill: '#ffffff'
      },
      preview: null,
      layerItems: [
        {
          type: 'bgRect',
          x: 0,
          y: 0,
          fill: '#FEFEFE',
          stroke: '#FED8D5',
          name: 'bgRect',
          text: 'Rectangle',
          rotation: 0,
          scaleX: 1,
          scaleY: 1
        },
        {
          type: 'bgImage',
          x: 0,
          y: 0,
          rotation: 0,
          scaleX: 1,
          scaleY: 1,
          draggable: true,
          name: 'bgImage',
          text: 'Background Image',
          fill: '#ffffff',
          image: null,
          width: null,
          height: null
        }
      ],
      isSelecting: false,
      layerIndex: 0,
      selectedShapeName: '',
      addImage: null,
      maxWidth: 0,
      scaleState: 0,
      isStillEditText: false,
      how_to_use_blog: configUrl.how_to_use_blog
    }
  },
  created() {
    const image = new window.Image()
    image.src = addImage
    image.onload = () => {
      // set image only when it is loaded
      this.addImage = image
    }
  },
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect',
      ImageSelect: 'lineRichmenuManager/getImageSelect',
      uploadSelectType: 'lineRichmenuManager/getUploadSelectType'
    }),

    buttonText() {
      return this.preview ? this.image.name : 'Select your background image'
    }
  },
  mounted() {
    this.maxWidth = this.$refs.setWidth.clientWidth
    this.scaleState =
      this.maxWidth / this.templateSelect.content_json.size.width
    // const container = document.querySelector(".container");
    // const observer = new ResizeObserver(() => {
    if (typeof this.ImageSelect.height === 'undefined') {
      this.stageSize.width =
        this.templateSelect.content_json.areas[this.ImageSelect].bounds.width
      this.stageSize.height =
        this.templateSelect.content_json.areas[this.ImageSelect].bounds.height
    } else {
      this.stageSize.width = this.ImageSelect.width
      this.stageSize.height = this.ImageSelect.height
    }
    // });
    // observer.observe(container);
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    dbEditText() {
      this.$refs.edit_text.focus()
    },
    onKeydown(e) {
      if (e.keyCode == 8 && this.layerIndex != null) {
        if (
          this.layerItems[this.layerIndex] &&
          this.layerItems[this.layerIndex].type != 'bgRect'
        ) {
          switch (this.layerItems[this.layerIndex].type) {
            case 'bgImage':
              this.clearImage()
              break
            case 'text':
              if (!this.isStillEditText) this.deleteItem(this.layerIndex)
              break

            default:
              break
          }
          const transformerNode = this.$refs.transformer.getNode()
          transformerNode.visible(false)
        }
      }
    },
    handleMouseEnter(e) {
      const stage = e.target.getStage()
      stage.container().style.cursor = 'pointer'
    },
    handleMouseLeave(e) {
      const stage = e.target.getStage()
      stage.container().style.cursor = 'default'
    },
    onButtonClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    dragCheckOver(index, e) {
      this.layerIndex = index
      if (e.target.attrs.x < 0) {
        this.$refs[e.target.attrs.name][0].getNode().setAttrs({
          x: 0
        })
      }
      if (e.target.attrs.y < 0) {
        this.$refs[e.target.attrs.name][0].getNode().setAttrs({
          y: 0
        })
      }
      if (e.target.attrs.x > this.stageSize.width - e.target.attrs.width) {
        this.$refs[e.target.attrs.name][0].getNode().setAttrs({
          x: this.stageSize.width - e.target.attrs.width
        })
      }
      if (e.target.attrs.y > this.stageSize.height - e.target.attrs.height) {
        this.$refs[e.target.attrs.name][0].getNode().setAttrs({
          y: this.stageSize.height - e.target.attrs.height
        })
      }
    },
    addIcons() {
      const image = new window.Image()
      var timestamp = JSON.stringify(new Date().getTime())
      image.src = icon
      image.onload = () => {
        this.layerItems.push({
          type: 'image',
          rotation: 0,
          x: 10 * this.scaleState,
          y: 10 * this.scaleState,
          width: 350 * this.scaleState,
          height: 150 * this.scaleState,
          scaleX: 1,
          scaleY: 1,
          draggable: true,
          ellipsis: true,
          image: image,
          text: timestamp,
          name: timestamp
        })
      }
    },
    fileInput() {
      // console.log(this.$refs.selectFile);
      this.$refs.uploader.click()
    },
    addText() {
      this.layerItems.push({
        type: 'text',
        rotation: 0,
        text: 'Edit text',
        fontFamily: 'Monospace',
        x: 50 * this.scaleState,
        y: 80 * this.scaleState,
        fill: '#000000',
        fontSize: 20,
        name: JSON.stringify(new Date().getTime()),
        draggable: true,
        ellipsis: true
      })
    },
    editText(e) {
      var vm = this
      var textNode = vm.$refs[e.target.attrs.name][0].getNode()
      textNode.hide()
      vm.$refs.transformer.getNode().hide()
      vm.$refs.layer.getNode().draw()

      var textPosition = textNode.absolutePosition()
      // console.log(textPosition);
      var stageBox = vm.$refs.stage
        .getNode()
        .container()
        .getBoundingClientRect()
      var areaPosition = {
        x: stageBox.left + textPosition.x + 250,
        y: stageBox.top + textPosition.y + 10
      }
      var textarea = document.createElement('textarea')
      document.body.appendChild(textarea)

      textarea.value = textNode.text()
      textarea.style.position = 'absolute'
      textarea.style.top = areaPosition.y + 'px'
      textarea.style.left = areaPosition.x + 'px'
      textarea.style.width = textNode.width() - textNode.padding() * 2 + 'px'
      textarea.style.height = textNode.height() - textNode.padding() * 2 + 'px'
      textarea.style.fontSize = textNode.fontSize() + 'px'
      textarea.style.border = 'none'
      textarea.style.padding = '0px'
      textarea.style.margin = '0px'
      textarea.style.overflow = 'hidden'
      textarea.style.background = 'none'
      textarea.style.outline = 'none'
      textarea.style.resize = 'none'
      textarea.style.lineHeight = textNode.lineHeight()
      textarea.style.fontFamily = textNode.fontFamily()
      textarea.style.transformOrigin = 'left top'
      textarea.style.textAlign = textNode.align()
      textarea.style.color = textNode.fill()
      var rotation = textNode.rotation()

      var transform = ''
      if (rotation) {
        transform += 'rotateZ(' + rotation + 'deg)'
      }

      var px = 0
      // also we need to slightly move textarea on firefox
      // because it jumps a bit
      var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
      if (isFirefox) {
        px += 2 + Math.round(textNode.fontSize() / 20)
      }
      transform += 'translateY(-' + px + 'px)'

      textarea.style.transform = transform

      // reset height
      textarea.style.height = 'auto'
      // after browsers resized it we can set actual value
      textarea.style.height = textarea.scrollHeight + 3 + 'px'

      textarea.focus()

      function removeTextarea() {
        textarea.parentNode.removeChild(textarea)
        window.removeEventListener('click', handleOutsideClick)
        textNode.show()
        vm.$refs.transformer.getNode().show()
        vm.$refs.transformer.getNode().forceUpdate()
        vm.$refs.layer.getNode().draw()
      }
      function setTextareaWidth(newWidth) {
        if (!newWidth) {
          // set width for placeholder
          newWidth = textNode.placeholder.length * textNode.fontSize()
        }
        // some extra fixes on different browsers
        var isSafari = /^((?!chrome|android).)*safari/i.test(
          navigator.userAgent
        )
        var isFirefox =
          navigator.userAgent.toLowerCase().indexOf('firefox') > -1
        if (isSafari || isFirefox) {
          newWidth = Math.ceil(newWidth)
        }

        var isEdge = document.documentMode || /Edge/.test(navigator.userAgent)
        if (isEdge) {
          newWidth += 1
        }
        textarea.style.width = newWidth + 'px'
      }
      textarea.addEventListener('keydown', function (e) {
        // hide on enter
        // but don't hide on shift + enter
        if (e.keyCode === 13 && !e.shiftKey) {
          textNode.text(textarea.value)
          removeTextarea()
        }
        // on esc do not set value back to node
        if (e.keyCode === 27) {
          removeTextarea()
        }
      })
      textarea.addEventListener('keydown', function () {
        var scale = textNode.getAbsoluteScale().x
        setTextareaWidth(textNode.width() * scale)
        textarea.style.height = 'auto'
        textarea.style.height =
          textarea.scrollHeight + textNode.fontSize() + 'px'
      })
      function handleOutsideClick(e) {
        if (e.target !== textarea) {
          textNode.text(textarea.value)
          removeTextarea()
        }
      }
      setTimeout(() => {
        window.addEventListener('click', handleOutsideClick)
      })
    },
    submitData() {
      this.$refs.transformer.getNode().nodes([])
      this.scaleState = 1
      this.$nextTick(() => {
        var vm = this
        vm.$refs.stage.getStage().toImage({
          callback: function (img) {
            if (
              vm.templateSelect.type === 'multi' ||
              vm.templateSelect.type === 'custom'
            ) {
              vm.templateSelect.content_json.areas[vm.ImageSelect].image = img
            } else if (vm.templateSelect.type === 'single') {
              vm.templateSelect.image_url = img
            }
            vm.$store.dispatch(
              'lineRichmenuManager/setTemplateSelect',
              vm.templateSelect
            )
            vm.$nextTick(() => {
              vm.$emit('goToPage', 3)
            })
          },
          mimeType: 'image/jpeg'
        })
      })
    },
    back() {
      this.$emit('goToPage', 3)
    },
    previewImage: function (files) {
      // var input = event.target;
      if (files.target.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          const image = new window.Image()
          image.src = e.target.result
          image.onload = () => {
            // set image only when it is loaded
            let index = this.layerItems.findIndex((el) => {
              return el.type == 'bgImage'
            })
            if (index != -1) {
              let scale = this.stageSize.width / image.width
              this.$set(this.layerItems[index], 'width', image.width * scale)
              this.$set(this.layerItems[index], 'height', image.height * scale)
            }
            this.preview = image
          }
        }
        this.image = files.target.files[0]
        reader.readAsDataURL(files.target.files[0])
      } else {
        this.clearImage()
      }
    },
    clearImage() {
      this.$refs.uploader.value = null
      this.image = null
      this.preview = null

      const transformerNode = this.$refs.transformer.getNode()
      transformerNode.visible(true)
    },
    handleTransformEnd(e) {
      if (typeof this.$refs[e.target.attrs.name] !== 'undefined') {
        this.$refs[e.target.attrs.name][0].getNode().setAttrs({
          width:
            this.$refs[e.target.attrs.name][0].getNode().width() *
            this.$refs[e.target.attrs.name][0].getNode().scaleX(),
          scaleX: 1,

          height:
            this.$refs[e.target.attrs.name][0].getNode().height() *
            this.$refs[e.target.attrs.name][0].getNode().scaleY(),
          scaleY: 1
        })
      }
      // shape is transformed, let us save new attrs back to the node
      // find element in our state
      const icon = this.layerItems.find(
        (r) => r.name === this.selectedShapeName
      )
      // update the state
      icon.x = e.target.x()
      icon.y = e.target.y()
      icon.rotation = e.target.rotation()
      icon.width = e.target.width()
      icon.height = e.target.height()
    },
    handleStageMouseDown(e) {
      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = ''
        this.updateTransformer()
        return
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === 'Transformer'
      if (clickedOnTransformer) {
        return
      }

      // find clicked icon by its name
      const name = e.target.name()
      const icon = this.layerItems.find((r) => r.name === name)
      if (icon) {
        this.selectedShapeName = name
      } else {
        this.selectedShapeName = ''
      }
      this.updateTransformer()
    },
    updateTransformer() {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode()
      // transformerNode.eventListeners.enabledAnchorsChange = ["middle-left", "middle-right"];
      const stage = transformerNode.getStage()
      const { selectedShapeName } = this

      const selectedNode = stage.findOne('.' + selectedShapeName)
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return
      }

      if (selectedNode) {
        // attach to another node
        transformerNode.nodes([selectedNode])
      } else {
        // remove transformer
        transformerNode.nodes([])
      }
      transformerNode.getLayer().batchDraw()
    },
    setSelect(index) {
      this.layerIndex = index
      const transformerNode = this.$refs.transformer.getNode()
      transformerNode.visible(true)
    },
    deleteItem(i) {
      if (this.layerIndex === i) {
        this.layerIndex = 0
        this.layerItems.splice(i, 1)
      } else {
        this.layerItems.splice(i, 1)
      }
    },
    resetItem(item) {
      if (item.type === 'bgRect') {
        item.fill === '#FEFEFE'
      } else if (item.type === 'bgImage') {
        this.preview = null
      }
    },
    rotate(degree) {
      this.layerItems[this.layerIndex].rotation =
        this.layerItems[this.layerIndex].rotation + degree
    },
    alignLeft() {
      if (this.layerItems[this.layerIndex].type !== 'bgRect') {
        this.layerItems[this.layerIndex].x = 0
      }
    },
    alignRight() {
      if (this.layerItems[this.layerIndex].type !== 'bgRect') {
        let dom = null,
          width = 0

        dom =
          this.$refs[this.layerItems[this.layerIndex].name] &&
          this.$refs[this.layerItems[this.layerIndex].name].length > 0
            ? this.$refs[this.layerItems[this.layerIndex].name][0].getNode()
            : null
        if (dom) width = dom.width()
        this.layerItems[this.layerIndex].x = this.stageSize.width - width
      }
    },
    alignCenter() {
      if (this.layerItems[this.layerIndex].type !== 'bgRect') {
        let dom = null,
          width = 0

        dom =
          this.$refs[this.layerItems[this.layerIndex].name] &&
          this.$refs[this.layerItems[this.layerIndex].name].length > 0
            ? this.$refs[this.layerItems[this.layerIndex].name][0].getNode()
            : null
        if (dom) width = dom.width()
        this.layerItems[this.layerIndex].x =
          this.stageSize.width / 2 - width / 2
      }
    },
    alignDown() {
      if (this.layerItems[this.layerIndex].type !== 'bgRect') {
        let dom = null,
          height = 0

        dom =
          this.$refs[this.layerItems[this.layerIndex].name] &&
          this.$refs[this.layerItems[this.layerIndex].name].length > 0
            ? this.$refs[this.layerItems[this.layerIndex].name][0].getNode()
            : null
        if (dom) height = dom.height()
        this.layerItems[this.layerIndex].y = this.stageSize.height - height
      }
    },
    alignUp() {
      if (this.layerItems[this.layerIndex].type !== 'bgRect') {
        this.layerItems[this.layerIndex].y = 0
      }
    },
    alignUpCenter() {
      if (this.layerItems[this.layerIndex].type !== 'bgRect') {
        let dom = null,
          height = 0
        dom =
          this.$refs[this.layerItems[this.layerIndex].name] &&
          this.$refs[this.layerItems[this.layerIndex].name].length > 0
            ? this.$refs[this.layerItems[this.layerIndex].name][0].getNode()
            : null

        if (dom) height = dom.height()
        this.layerItems[this.layerIndex].y =
          this.stageSize.height / 2 - height / 2
      }
    },
    addRectangle() {
      // this.layerItems.push({
      //   text: "RectangleNew",
      //   type: "bgRect",
      //   rotation: 0,
      //   scaleX: 1,
      //   scaleY: 1,
      //   fill: "hsl(0, 50%, 50%)",
      //   x: 0,
      //   y: 0,
      //   stroke: "#FED8D5",
      //   width: 100,
      //   height: 100,
      //   name: JSON.stringify(new Date().getTime()),
      //   draggable: true,
      // });
      //  vm.templateSelect.areas[vm.ImageSelect].image = img;
      // this.templateSelect.areas.push({
      //   bounds: {
      //     x: 0,
      //     y: 0,
      //     width: 119.04,
      //     height: 120.42,
      //     stroke: "#FED8D5",
      //   },
      //   action: {},
      // });
    }
  }
}
</script>
<style lang="scss" scoped>
.v-btn--fab.v-size--small {
  padding: 15px;
  height: 23px;
  width: 23px;
  border: none;
  margin-right: 5px;
}
.v-list-item__action {
  margin: 0px 0;
}
.card-reports {
  position: fixed;
  top: 80px;
  right: 10px;
  width: 200px;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
}
.v-expansion-panel-header {
  padding: 10px;
  min-height: 40px;
}
.v-expansion-panel-content__wrap {
  padding: 0 0px 10px;
}
.v-list {
  padding: 0px 0;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 40px;
}
.v-list-item {
  padding: 0 0px;
}
</style>
